var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-overlay",class:{ visible: _vm.visible, absolute: Boolean(_vm.name), light: _vm.islightOverlay }},[_c('div',{staticClass:"modal-popup-wrap"},[_c(_vm.modal.name,{tag:"component",attrs:{"is-absolute":Boolean(_vm.name),"options":_vm.modal.options},on:{"close":_vm.close}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }